import { useNavigate, useParams } from "react-router-dom";
import { useStartQuiz } from "../../quiz/hooks/useStartQuiz";
import { useEffect } from "react";

function StartQuiz({ quizId, setStartTheQuiz }) {
  const { grade, courseId, lectureId } = useParams();
  const navigate = useNavigate();

  const { isSuccess, quiz } = useStartQuiz({ courseId, lectureId, quizId });

  useEffect(() => {
    if (isSuccess) {
      const {
        attempt: { id: attemptId }
      } = quiz;

      navigate(
        `/${grade}/courses/${courseId}/lectures/${lectureId}/quiz/${quizId}/${attemptId}`)


      setStartTheQuiz(false)
    }
  }, [isSuccess, quiz, grade, courseId, lectureId, quizId, navigate, setStartTheQuiz]);

  return null;
}

export default StartQuiz;
